import type {
  IJobRecordChoiceSummary,
  IJobRecordMetricsSummary,
  IQuestion,
  IQuestionRevision,
} from '@quesmed/types/models';
import { create } from 'zustand';
import { getMetricsSummary } from '@/config';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

interface QuestionState {
  question: IQuestion | null;
  preview: boolean;
  questionId: number;
  selectedRevisionId: number | null;
  commentModal: boolean;
  revisionModal: boolean;
  questionSettingsModal: boolean;
  previewRevision: IQuestionRevision | null;
  updateLoading: boolean;
  choiceSummary: IJobRecordChoiceSummary[] | null;
  metricsSummary: IJobRecordMetricsSummary | null;
  questionLayout: 'horizontal' | 'vertical';
  setQuestionLayout: (layout: 'horizontal' | 'vertical') => void;
  reset: () => void;
  setPreview: (val: boolean) => void;
  setQuestionId: (id: number) => void;
  setSelectedRevisionId: (id: number | null) => void;
  setQuestion: (question?: IQuestion) => void;
  setCommentModal: (isOpen: boolean) => void;
  setRevisionModal: (isOpen: boolean) => void;
  setQuestionSettingsModal: (isOpen: boolean) => void;
  setPreviewRevision: (revision: IQuestionRevision) => void;
  setUpdateLoading: (loading: boolean) => void;
}

const initialState: OmitFunctions<QuestionState> = {
  updateLoading: false,
  question: null,
  previewRevision: null,
  // defaultExpandedKeys: [],
  preview: false,
  questionId: 4,
  selectedRevisionId: null,
  commentModal: false,
  revisionModal: false,
  questionSettingsModal: false,
  choiceSummary: null,
  metricsSummary: null,
  questionLayout: 'horizontal',
};

export const questionState = create<QuestionState>()((set) => ({
  ...initialState,
  reset: () => {
    set(initialState);
  },
  setPreview: (preview) => set({ preview }),
  setQuestionId: (questionId) => set({ questionId }),
  setSelectedRevisionId: (selectedRevisionId) => set({ selectedRevisionId }),
  setQuestionLayout: (layout) => set({ questionLayout: layout }),
  setQuestion: (question) => {
    if (!question) {
      set({
        question: null,
        choiceSummary: null,
        metricsSummary: null,
      });
      return;
    }
    const { choiceSummary, metricsSummary } = getMetricsSummary(question);
    set({
      question,
      choiceSummary,
      metricsSummary,
    });
  },
  // setDefaultExpandedKeys: (defaultExpandedKeys) => {
  //   console.log('setDefaultExpandedKeys', defaultExpandedKeys);
  //   set({ defaultExpandedKeys });
  // },
  setCommentModal: (isOpen) => set({ commentModal: isOpen }),
  setRevisionModal: (isOpen) => set({ revisionModal: isOpen }),
  setQuestionSettingsModal: (isOpen) => set({ questionSettingsModal: isOpen }),
  setPreviewRevision: (revision) => set({ previewRevision: revision }),
  setUpdateLoading: (loading) => set({ updateLoading: loading }),
}));

export const useQuestionState = () => questionState((state) => state);
export const useQuestion = createSelectors(questionState);
